import React, { Fragment, forwardRef, useEffect, useState } from 'react'
import ReactDOM from 'react-dom'
import moment from 'moment'
import ClickAway from '~/Common-Objects/ClickAway'
import Drawer from '~/Common-Objects/UI/Drawer/Drawer.jsx'
import FormError from '~/Common-Objects/UI/Forms/FormError/FormError'
import FormWarning from '~/Common-Objects/UI/Forms/FormError/FormWarning'
import Icons from '~/Common-Objects/UI/Icons/index'
import PopOver from '~/Common-Objects/UI/Popover/index'
import TelephoneInput from '~/Common-Objects/UI/Forms/TelephoneInput/TelephoneInput'
import store from '~/data/store/store'

import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'

import SmileyPicker from './smileyPicker'
import CustomFieldPicker from './customFieldPicker'
import * as siteMaster from '~/data/actions/siteActions' //now we can use user actions here
import { connect, useSelector } from 'react-redux'
import MaskedInput from 'react-text-mask'
import AiContentGenerator from '~/pages/cp/includes/ai/contentGenerator'
import CampaignMergeTags from '~/pages/cp/includes/mergeTags/campaignMergeTags'
import AiSubjectLineSuggestor from '~/Common-Objects/AiSubjectLineSuggestor'
import { Trans } from 'react-i18next'

@connect((store) => {
    return { user: store.user, browser: store.browser, permissionStore: store.permission, site: store.siteMaster }
})
export default class TextInput extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            suggestions: [],
            showSuggestions: false,
            date: '',
            focused: false,
            dateFormat: this.props.dateFormat || 'yyyy-MM-dd',
            inputSelection: { start: 0, end: 0 },
            selectedSuggestion: null,
            currVal: '',
            showAiSuggestionFeedback: false
        }
        this.keyDown = this.keyDown.bind(this)
        this.onKeyPress = this.onKeyPress.bind(this)
        this.singleDateChange = this.singleDateChange.bind(this)
        this.multiDateChange = this.multiDateChange.bind(this)
        this.clickToChange = this.clickToChange.bind(this)
        this.openSmileyPicker = this.openSmileyPicker.bind(this)
        this.closePopup = this.closePopup.bind(this)
        this.pickSmiley = this.pickSmiley.bind(this)
        this.openCustomFieldPicker = this.openCustomFieldPicker.bind(this)
        this.pickField = this.pickField.bind(this)
        this.isOutsideRange = this.isOutsideRange.bind(this)
        this.clickToClear = this.clickToClear.bind(this)
        this.telNoChange = this.telNoChange.bind(this)
        this.selectSuggestion = this.selectSuggestion.bind(this)
        this.onFocus = this.onFocus.bind(this)
        this.onBlur = this.onBlur.bind(this)
        this.onClick = this.onClick.bind(this)
        this.clickAway = this.clickAway.bind(this)
        this.multiDateStart = React.createRef()
        this.multiDateEnd = React.createRef()
        this.openAiContentGenerator = this.openAiContentGenerator.bind(this)
        this.openMergeTags = this.openMergeTags.bind(this)
        this.pickSubjectLinkSuggestion = this.pickSubjectLinkSuggestion.bind(this)
    }

    componentDidMount() {
        if (this.props.focus && this.nameInput) {
            this.nameInput.focus()
        }
        if (this.props.focus && this.props.inputRef && this.props.inputRef.current) {
            this.props.inputRef.current.focus()
        }

        var state = store.getState()
        var dateFormat = 'yyyy-MM-dd'
        if (state.user && state.user.userData && state.user.userData.dateFormat && !this.props.dateFormat) {
            dateFormat = state.user.userData.dateFormat

            if (dateFormat && dateFormat.length) {
                dateFormat = dateFormat.replace(/DD/g, 'dd').replace(/YY/g, 'yy')
                if (this.props.includeTime) {
                    dateFormat += ' HH:mm'
                }
            }
        }
        this.setState({
            dateFormat
        })

        if (this.props.suggestions && this.props.suggestions.length) {
            const found = this.props.suggestions.filter(
                (s) =>
                    this.props.value &&
                    s.toLowerCase().indexOf(this.props.value.toLowerCase()) > -1 &&
                    s.toLowerCase() !== this.props.value.toLowerCase()
            )
            this.setState({ suggestions: found })
        }
    }

    componentDidUpdate(prevProps) {
        if (
            this.props.suggestions &&
            prevProps.suggestions &&
            this.props.suggestions.length !== prevProps.suggestions.length
        ) {
            const found = this.props.suggestions.filter(
                (s) =>
                    this.props.value &&
                    s.toLowerCase().indexOf(this.props.value.toLowerCase()) > -1 &&
                    s.toLowerCase() !== this.props.value.toLowerCase()
            )
            this.setState({ suggestions: found })
        }
        if (prevProps.value !== this.props.value && this.props.value !== this.state.selectedSuggestion) {
            if (this.props.suggestions && this.props.suggestions.length) {
                const found = this.props.suggestions.filter(
                    (s) =>
                        this.props.value &&
                        s.toLowerCase().indexOf(this.props.value.toLowerCase()) > -1 &&
                        s.toLowerCase() !== this.props.value.toLowerCase()
                )
                this.setState({ suggestions: found, showSuggestions: Boolean(found.length), selectedSuggestion: null })
            }
        }
        if (this.state.showSuggestions && this.props.hideDropdown !== prevProps.hideDropdown) {
            this.setState({ showSuggestions: false })
        }
    }

    selectSuggestion(value) {
        this.props.onChange({
            target: { value: value, name: this.props.name },
            currentTarget: { value: value, name: this.props.name }
        })
        this.setState({ showSuggestions: false, selectedSuggestion: value })
    }

    onKeyPress(event) {
        if (this.props.onEnterPress && event.key == 'Enter') {
            this.props.onEnterPress()
            event.stopPropagation()
            event.preventDefault()
            return false
        } else if (this.props.onKeyPress) {
            this.props.onKeyPress(event)
        }
    }

    keyDown(evt) {
        if (evt.key === 'Escape' && this.props.onEscapePress) {
            this.props.onEscapePress()
            evt.stopPropagation()
            evt.preventDefault()
            return false
        }
        if (this.props.onKeyDown && typeof this.props.onKeyDown === 'function') {
            this.props.onKeyDown(evt)
        }
    }

    clickToChange() {
        if (this.props.clickToChangeClicked) this.props.clickToChangeClicked(this.nameInput.value)
    }

    clickToClear() {
        this.props.onChange({
            target: {
                name: this.props.name,
                value: ''
            },
            currentTarget: {
                name: this.props.name,
                value: ''
            }
        })
        this.setState({ currVal: '' })
    }

    openAiContentGenerator() {
        var ourEl = document.getElementById(this.props.id)
        var startChar = ourEl.selectionStart
        var endChar = ourEl.selectionEnd

        this.setState({ inputSelection: { start: startChar, end: endChar } })

        var drawerContent = (
            <AiContentGenerator
                contentType='subject'
                selectedText={ourEl && startChar !== endChar ? ourEl.value.substring(startChar, endChar) : undefined}
                insertText={this.pickField}
                close={() => {
                    this.props.dispatch(siteMaster.alterSiteDrawer(false, false, 'right', null, true))
                }}
            />
        )
        this.props.dispatch(
            siteMaster.alterSiteDrawer(true, false, 'right', drawerContent, true, '700px', 'drawer_dark')
        )
    }

    openMergeTags() {
        var ourEl = document.getElementById(this.props.id)
        var startChar = ourEl.selectionStart
        var endChar = ourEl.selectionEnd

        this.setState({ inputSelection: { start: startChar, end: endChar } })

        let drawerContent = (
            <CampaignMergeTags
                hasWorkflowEmails={false}
                includeSubscriber={true}
                includeSubCustomFields={true}
                close={() => {
                    if (this.props.mergeTagsModal) {
                        this.props.dispatch(siteMaster.alterFullpage(null))
                    } else {
                        this.props.dispatch(siteMaster.alterSiteDrawer(false, false, 'right', null, true))
                    }
                }}
                AutomationId={this.props.AutomationId}
                insertMergeTag={this.pickField}
                includeSystem={this.props.includeSysemMergeTags}
                includeRss={this.props.includeRssMergeTags}
            />
        )
        if (this.props.mergeTagsModal) {
            const width = 800
            const fullpage = (
                <Drawer
                    standalone={true}
                    isOpen={true}
                    width={width}
                    showClose={true}
                    close={() => this.props.dispatch(siteMaster.alterFullpage(null))}
                >
                    {drawerContent}
                </Drawer>
            )
            this.props.dispatch(siteMaster.alterFullpage(fullpage))
        } else {
            this.props.dispatch(siteMaster.alterSiteDrawer(true, false, 'right', drawerContent, true, '800px'))
        }
    }
    openCustomFieldPicker() {
        var ourEl = document.getElementById(this.props.id)
        var startChar = ourEl.selectionStart
        var endChar = ourEl.selectionEnd

        this.setState({ inputSelection: { start: startChar, end: endChar } })

        var drawerContent = <CustomFieldPicker onPick={this.pickField} />
        this.props.dispatch(siteMaster.alterSiteDrawer(true, true, 'right', drawerContent, true, '600px'))
    }

    isOutsideRange(date) {
        if (this.props.disallowPast) {
            if (moment() > date && !date.isSame(moment(), 'day')) {
                return true
            }
        }
        return false
    }

    pickField(theChar) {
        var ourEl = document.getElementById(this.props.id)
        var startPos = this.state.inputSelection.start
        var endPos = this.state.inputSelection.end
        ourEl.focus()

        if (document.selection) {
            sel = document.selection.createRange()
            sel.text = theChar
        } else {
            ourEl.value =
                ourEl.value.substring(0, startPos) + theChar + ourEl.value.substring(endPos, ourEl.value.length)

            this.props.onChange({ target: ourEl, currentTarget: ourEl })
        }
        ourEl.setSelectionRange(startPos + theChar.length, startPos + theChar.length)
        if (this.props.mergeTagsModal) {
            this.props.dispatch(siteMaster.alterFullpage(null))
        } else {
            this.closePopup()
        }
    }

    pickSubjectLinkSuggestion(suggestion) {
        var ourEl = document.getElementById(this.props.id)
        ourEl.value = suggestion
        this.props.onChange({ target: ourEl, currentTarget: ourEl })
        this.setState({ showAiSuggestionFeedback: true })
    }

    openSmileyPicker() {
        var ourEl = document.getElementById(this.props.id)
        var startChar = ourEl.selectionStart
        var endChar = ourEl.selectionEnd

        this.setState({ inputSelection: { start: startChar, end: endChar } })

        var drawerContent = <SmileyPicker onPick={this.pickSmiley} />
        this.props.dispatch(siteMaster.alterSiteDrawer(true, true, 'right', drawerContent, true, '400px'))
    }

    pickSmiley(theChar) {
        var ourEl = document.getElementById(this.props.id)
        var startPos = this.state.inputSelection.start
        var endPos = this.state.inputSelection.end
        ourEl.focus()

        if (document.selection) {
            sel = document.selection.createRange()
            sel.text = theChar
        } else {
            ourEl.value =
                ourEl.value.substring(0, startPos) + theChar + ourEl.value.substring(endPos, ourEl.value.length)

            this.props.onChange({ target: ourEl, currentTarget: ourEl })
        }
        ourEl.setSelectionRange(startPos + theChar.length, startPos + theChar.length)
        this.closePopup()
    }

    closePopup() {
        this.props.dispatch(siteMaster.alterSiteDrawer(false, false, 'right', undefined, true))
    }

    telNoChange(valid, value) {
        this.props.onChange({
            target: { name: this.props.name, value },
            currentTarget: { name: this.props.name, value },
            valid
        })
    }

    singleDateChange(newDate) {
        this.setState({ date: newDate })
        this.props.onChange(this.props.field || this.props.name, moment(newDate))
        if (this.props.onBlur) this.props.onBlur()
    }

    multiDateChange(newVal, targetName) {
        var startDate = this.props.startDate
        var endDate = this.props.endDate

        if (targetName == 'startDate') {
            startDate = moment(newVal)
        }
        if (targetName == 'endDate') {
            endDate = moment(newVal)
        }
        this.props.updateDate({ startDate, endDate })
    }

    onFocus(e) {
        if (this.props.onFocus && typeof this.props.onFocus === 'function') {
            this.props.onFocus(e)
        }
        if (this.state.suggestions.length || this.props.dropdown) {
            this.setState({ showSuggestions: true })
        }
    }

    onClick(e) {
        if (this.props.onClick && typeof this.props.onClick === 'function') {
            this.props.onClick(e)
        }
        if ((this.state.suggestions.length || this.props.dropdown) && !this.state.showSuggestions) {
            this.setState({ showSuggestions: true })
        }
    }

    onBlur(e) {
        if (this.props.onBlur && typeof this.props.onBlur === 'function') {
            this.props.onBlur(e)
        }
        if (this.state.suggestions.length || this.props.dropdown) {
            setTimeout(() => {
                this.setState({ showSuggestions: false })
            }, 100)
        }
    }

    clickAway() {
        if (this.state.showSuggestions) {
            this.setState({ showSuggestions: false })
        }
    }

    render() {
        var thisClasses = 'txtInput '
        var errorTxt = []

        if (this.props.error) {
            thisClasses += 'button-warning '
            if (this.props.error != ' ') {
                errorTxt.push(<FormError key={errorTxt.length}>{this.props.error}</FormError>)
            }
        }

        if (this.props.warning) {
            thisClasses += 'button-warning '
            if (this.props.warning != ' ') {
                errorTxt.push(<FormWarning key={errorTxt.length}>{this.props.warning}</FormWarning>)
            }
        }

        if (this.props.className) {
            thisClasses += this.props.className
        }

        var inputType = 'text'
        if (this.props.type) {
            inputType = this.props.type.toLowerCase()
        }

        var thisDate = undefined
        if (inputType === 'date' || inputType === 'datetime' || inputType === 'time') {
            if (typeof this.props.value === 'object' || (this.props.value && this.props.value.length > 3)) {
                thisDate = moment.tz(moment(this.props.value), this.props.user.userData.timeZone).toDate()
                // thisDate.setTime(thisDate.getTime() + (thisDate.getTimezoneOffset() * 60 * 1000))
            }
        }

        var isMobile = window.innerWidth <= 480

        var thisStyle = {}
        if (this.props.style) {
            thisStyle = JSON.parse(JSON.stringify(this.props.style))
        }
        if (this.props.clickToChange) {
            thisStyle.paddingRight = '35px'
        }

        var value = this.props.value
        if (value === null) value = undefined

        var outerStyle = this.props.outerStyle || {}
        var finalInputType = this.props.type || 'text'

        var minDate = ''
        if (this.props.disallowPast) {
            minDate = moment().toDate()
        }

        var multiDateStartMin = minDate
        var multiDateEndMax = undefined
        if (inputType === 'multidate' && this.props.maxRangeDays && this.props.startDate && this.props.endDate) {
            const rangeStartMin = moment(this.props.endDate).subtract(this.props.maxRangeDays, 'days').toDate()
            if (!multiDateStartMin || moment(rangeStartMin).isAfter(multiDateStartMin)) {
                multiDateStartMin = rangeStartMin
            }
            multiDateEndMax = moment(this.props.startDate).add(this.props.maxRangeDays, 'days').toDate()
        }

        let label = ''
        if ((this.props.label && this.props.labelOptions) || this.props.labelOptions) {
            label = (
                <div className='txtInput_label_flex'>
                    <div className='txtInput_label'>{this.props.label}</div>
                    <div className='txtInput_labelOptions'>{this.props.labelOptions}</div>
                </div>
            )
        } else if (this.props.label && this.props.labelSub) {
            label = (
                <div className='txtInput_label_sub'>
                    <div className='txtInput_label'>{this.props.label}</div>
                    <div className='txtInput_labelSub'>{this.props.labelSub}</div>
                </div>
            )
        } else if (this.props.label) {
            label = <div className='txtInput_label'>{this.props.label}</div>
        }

        let explainer = ''
        if (this.props.explainer) {
            explainer = <div className='txtInput_explainer'>{this.props.explainer}</div>
        }

        if (this.props.explainerEnd) {
            explainer = (
                <div className='quickFlex' style={{ justifyContent: 'space-between' }}>
                    {explainer} {this.props.explainerEnd}
                </div>
            )
        }

        let outerClassName = 'textInputWrapper'
        if (this.props.outerClassName) outerClassName += ' ' + this.props.outerClassName

        let iconLeft = ''
        if (this.props.iconLeft) {
            iconLeft = <div className='textInputIconLeft'>{this.props.iconLeft}</div>
            thisStyle.paddingLeft = '40px'
        }
        var iconRight = []
        if (this.props.iconRight) {
            // do this so we can add key to component
            iconRight.push(<Fragment key={iconRight.length}>{this.props.iconRight}</Fragment>)
        }

        if (inputType == 'emojipicker' && this.props.id) {
            iconRight.push(
                <Icons
                    icon='smiley'
                    key={iconRight.length}
                    title='Insert an Emoji'
                    alt='Insert an Emoji'
                    data-tooltip-content='Insert Emoji'
                    data-tooltip-id='emoji'
                    onClick={this.openSmileyPicker}
                />
            )
        }

        if (this.props.customFields) {
            iconRight.push(
                <Icons
                    key={iconRight.length}
                    icon='list'
                    title='Insert Custom Field'
                    alt='Insert Custom Field'
                    data-tooltip-content='Insert Custom Field'
                    data-tooltip-id='customfields'
                    onClick={this.openCustomFieldPicker}
                />
            )
        }
        if (this.props.mergeTags) {
            iconRight.push(
                <Icons
                    key={iconRight.length}
                    icon='mergeTags'
                    title='Merge Tags'
                    alt='Merge Tags'
                    data-tooltip-content='Merge Tags'
                    data-tooltip-id='mergeTags'
                    onClick={this.openMergeTags}
                />
            )
        }
        if (this.props.aiContent) {
            if (this.props.aiInlineSuggestions) {
                iconRight.push(
                    <PopOver
                        trigger={
                            <Icons
                                key={iconRight.length}
                                icon='sparkle'
                                title='Subject Lines Optimised by AI'
                                alt='Subject Lines Optimised by AI'
                                data-tooltip-content='Subject Lines Optimised by AI'
                                data-tooltip-id='aiContent'
                                style={{ height: '20px', width: '20px' }}
                                postHogTag='ai-subject-suggestor-trigger-text-input'
                            />
                        }
                        sideOffset={20}
                        side={'right'}
                        align={'top'}
                        alignOffset={10}
                        avoidCollisions={true}
                        padding={false}
                        onInteractOutside={() => this.setState({ showAiSuggestionFeedback: true })}
                    >
                        <AiSubjectLineSuggestor
                            onSuggestionSelected={this.pickSubjectLinkSuggestion}
                            templateId={this.props.templateId}
                        />
                    </PopOver>
                )
            } else {
                iconRight.push(
                    <Icons
                        key={iconRight.length}
                        icon='sparkle'
                        title='AI Content Assistant'
                        alt='AI Content Assistant'
                        data-tooltip-content='AI Content Assistant'
                        data-tooltip-id='aiContent'
                        onClick={this.openAiContentGenerator}
                        style={{ height: '20px', width: '20px' }}
                        postHogTag='ai-content-assistant-trigger-text-input'
                    />
                )
            }
        }

        if (iconRight.length) {
            iconRight = (
                <div className='textInputIcon' style={this.props.iconRightStyle}>
                    {iconRight}
                </div>
            )
            thisStyle.paddingRight = '40px'
        }

        return (
            <ClickAway
                onClickAway={this.clickAway}
                enabled={Boolean(this.props.clickAway || this.props.dropdown)}
            >
                <div className={outerClassName} style={outerStyle}>
                    {label}

                    <div className='txtInputInnerHolder'>
                        {iconLeft}
                        {inputType === 'multidate' && (
                            <div className={'DateRangePicker ' + this.props.className} style={{ position: 'relative' }}>
                                <DatePicker
                                    popperContainer={
                                        this.props.datePopperContainer
                                            ? ({ children }) => {
                                                  return ReactDOM.createPortal(children, document.body)
                                              }
                                            : undefined
                                    }
                                    onChange={(newVal) => this.multiDateChange(newVal, 'startDate')}
                                    selected={this.props.startDate.toDate()}
                                    disabled={this.props.disabled}
                                    dateFormat={this.state.dateFormat || 'YYYY-MM-DD'}
                                    selectsStart
                                    showYearDropdown
                                    id={this.props.id}
                                    focused={this.state.focused}
                                    maxDate={this.props.endDate.toDate()}
                                    className={'DateRangePickerInput ' + this.props.dateInputClass}
                                    minDate={multiDateStartMin}
                                    ref={this.multiDateStart}
                                    customInput={<CustomDatePicker classes={thisClasses} readOnlyInput={true} />}
                                />
                                <div className='DateRangeDivider'>
                                    <Icons icon='arrowRight' color='#969695' className='vertical-center' />
                                </div>
                                <DatePicker
                                    popperContainer={
                                        this.props.datePopperContainer
                                            ? ({ children }) => {
                                                  return ReactDOM.createPortal(children, document.body)
                                              }
                                            : undefined
                                    }
                                    onChange={(newVal) => this.multiDateChange(newVal, 'endDate')}
                                    selected={this.props.endDate.toDate()}
                                    disabled={this.props.disabled}
                                    dateFormat={this.state.dateFormat || 'YYYY-MM-DD'}
                                    selectsEnd
                                    showYearDropdown
                                    id={this.props.id}
                                    focused={this.state.focused}
                                    minDate={this.props.startDate.toDate()}
                                    maxDate={multiDateEndMax}
                                    className={'DateRangePickerInput ' + this.props.dateInputClass}
                                    ref={this.multiDateEnd}
                                    customInput={<CustomDatePicker classes={thisClasses} readOnlyInput={true} />}
                                />
                            </div>
                        )}

                        {inputType === 'date' && (
                            <DatePicker
                                popperContainer={
                                    this.props.datePopperContainer
                                        ? ({ children }) => {
                                              return ReactDOM.createPortal(children, document.body)
                                          }
                                        : undefined
                                }
                                onCalendarOpen={this.props.handleCalendarOpen}
                                onCalendarClose={this.props.handleCalendarClose}
                                onChange={this.singleDateChange}
                                selected={thisDate}
                                disabled={this.props.disabled}
                                dateFormat={this.state.dateFormat}
                                readOnly={this.props.readOnly}
                                id={this.props.id}
                                showYearDropdown
                                focused={this.state.focused}
                                onFocusChange={({ focused }) => this.setState({ focused })}
                                minDate={minDate}
                                ref={
                                    this.props.inputRef ||
                                    ((input) => {
                                        this.nameInput = input
                                    })
                                }
                                customInput={
                                    <CustomDatePicker
                                        hideIcon={this.props.hideIcon}
                                        classes={thisClasses + ' SingleDatePicker'}
                                        single={true}
                                        onDateChange={this.singleDateChange}
                                    />
                                }
                            />
                        )}

                        {inputType === 'time' && (
                            <DatePicker
                                popperContainer={
                                    this.props.datePopperContainer
                                        ? ({ children }) => {
                                              return ReactDOM.createPortal(children, document.body)
                                          }
                                        : undefined
                                }
                                showTimeSelect
                                showTimeSelectOnly
                                onCalendarOpen={this.props.handleCalendarOpen}
                                onCalendarClose={this.props.handleCalendarClose}
                                timeIntervals={this.props.timeInterval || 5}
                                onChange={this.singleDateChange}
                                selected={thisDate}
                                timeCaption='Time'
                                disabled={this.props.disabled}
                                focused={this.state.focused}
                                onFocusChange={({ focused }) => this.setState({ focused })}
                                timeFormat='HH:mm'
                                dateFormat={'HH:mm'}
                                ref={this.props.inputRef || ((input) => (this.nameInput = input))}
                                id={this.props.id}
                                customInput={
                                    <CustomDatePicker
                                        readOnlyInput={true}
                                        classes={thisClasses + ' SingleDatePicker'}
                                        single={true}
                                        id={this.props.id}
                                        timeOnly={true}
                                    />
                                }
                            />
                        )}

                        {inputType === 'datetime' && (
                            <DatePicker
                                popperContainer={
                                    this.props.datePopperContainer
                                        ? ({ children }) => {
                                              return ReactDOM.createPortal(children, document.body)
                                          }
                                        : undefined
                                }
                                onCalendarOpen={this.props.handleCalendarOpen}
                                onCalendarClose={this.props.handleCalendarClose}
                                onChange={this.singleDateChange}
                                selected={thisDate}
                                disabled={this.props.disabled}
                                id={this.props.id}
                                showTimeSelect
                                timeCaption='Time'
                                showYearDropdown
                                focused={this.state.focused}
                                onFocusChange={({ focused }) => this.setState({ focused })}
                                dateFormat={this.state.dateFormat + ' HH:mm'}
                                timeFormat='HH:mm'
                                timeIntervals={this.props.timeInterval || 5}
                                minDate={minDate}
                                ref={this.props.inputRef || ((input) => (this.nameInput = input))}
                                customInput={
                                    <CustomDatePicker
                                        readOnlyInput={true}
                                        classes={thisClasses + ' SingleDatePicker'}
                                        single={true}
                                        id={this.props.id}
                                    />
                                }
                            />
                        )}

                        {inputType == 'telno' && (
                            <TelephoneInput
                                name={this.props.name}
                                value={value}
                                onChange={this.telNoChange}
                                defaultCountry={this.props.defaultCountry || 'gb'}
                                onlyCountries={this.props.onlyCountries}
                                allowDropdown={this.props.allowDropdown}
                                className={thisClasses}
                                id={this.props.id}
                                disabled={this.props.disabled ? 'disabled' : ''}
                                ref={
                                    this.props.inputRef ||
                                    ((input) => {
                                        this.nameInput = input
                                    })
                                }
                                readOnly={this.props.readOnly ? 'readonly' : ''}
                                style={thisStyle}
                            />
                        )}

                        {inputType == 'plaintext' && (
                            <div style={{ position: 'relative', width: '100%' }}>
                                <div className={thisClasses} style={{ overflow: 'auto' }}>
                                    {value}
                                </div>
                            </div>
                        )}
                        {inputType !== 'date' &&
                            inputType != 'multidate' &&
                            inputType != 'telno' &&
                            inputType != 'plaintext' &&
                            inputType != 'time' &&
                            inputType !== 'datetime' &&
                            !this.props.mask && (
                                <input
                                    type={finalInputType}
                                    min={this.props.min}
                                    max={this.props.max}
                                    placeholder={this.props.placeholder}
                                    name={this.props.name}
                                    value={value}
                                    onChange={this.props.onChange}
                                    onKeyPress={this.onKeyPress}
                                    className={thisClasses}
                                    autoComplete={this.props.autocomplete}
                                    id={this.props.id}
                                    disabled={this.props.disabled ? 'disabled' : ''}
                                    ref={
                                        this.props.inputRef ||
                                        ((input) => {
                                            this.nameInput = input
                                        })
                                    }
                                    onBlur={this.onBlur}
                                    onFocus={this.onFocus}
                                    onClick={this.onClick}
                                    onMouseDown={this.props.onMouseDown}
                                    readOnly={this.props.readOnly ? 'readonly' : ''}
                                    style={thisStyle}
                                    maxLength={this.props.maxlength}
                                    onKeyUp={this.props.onKeyUp}
                                    onKeyDown={this.keyDown}
                                    required={this.props.required}
                                    autoFocus={this.props.autoFocus}
                                    onPaste={this.props.onPaste}
                                    tabIndex={this.props.tabindex}
                                />
                            )}
                        {inputType !== 'date' &&
                            inputType != 'multidate' &&
                            inputType != 'telno' &&
                            inputType != 'plaintext' &&
                            !!this.props.mask && (
                                <MaskedInput
                                    type={finalInputType}
                                    mask={this.props.mask}
                                    placeholder={this.props.placeholder}
                                    name={this.props.name}
                                    value={value}
                                    onChange={this.props.onChange}
                                    onKeyPress={this.onKeyPress}
                                    className={thisClasses}
                                    showMask={true}
                                    guide={false}
                                    autoComplete={this.props.autocomplete}
                                    id={this.props.id}
                                    disabled={this.props.disabled ? 'disabled' : ''}
                                    ref={
                                        this.props.inputRef ||
                                        ((input) => {
                                            this.nameInput = input
                                        })
                                    }
                                    onBlur={this.onBlur}
                                    onFocus={this.onFocus}
                                    onClick={this.onClick}
                                    readOnly={this.props.readOnly ? 'readonly' : ''}
                                    style={thisStyle}
                                    maxLength={this.props.maxlength}
                                />
                            )}
                        {this.props.clickToChange && (
                            <div
                                className={
                                    'icon-magnifier textInputIcon ' + (this.props.clickToClear ? 'leftMore' : '')
                                }
                                onClick={this.clickToChange}
                            />
                        )}
                        {this.props.clickToClear && (
                            <div className='icon-cross2 textInputIcon' onClick={this.clickToClear} />
                        )}
                        {iconRight}
                    </div>
                    {this.props.aiInlineSuggestions && this.state.showAiSuggestionFeedback && (
                        <span style={{ marginTop: '8px', fontSize: '12px', color: 'var(--neutral-500)' }}>
                            <Trans i18nKey='tcampaigns:add.aiSubjectLineSuggestor.feedback'>
                                Were these suggested subject lines useful?{' '}
                                <a className='ai-subject-suggestor-feedback'>Give feedback</a>
                            </Trans>
                        </span>
                    )}
                    {errorTxt}
                    {Boolean(this.state.suggestions.length) && this.state.showSuggestions && (
                        <div
                            className={'dropDownContainer show'}
                            style={{ padding: 0, top: this.props.label ? undefined : 41 }}
                        >
                            {this.state.suggestions.sort().map((value, index) => {
                                return (
                                    <div
                                        className='dropDownContainerItem text-sml cursor-pointer'
                                        key={index}
                                        onClick={() => this.selectSuggestion(value)}
                                    >
                                        {value}
                                    </div>
                                )
                            })}
                        </div>
                    )}
                    {Boolean(this.props.dropdown) && this.state.showSuggestions && (
                        <div className={'dropDownContainer show'} style={this.props.dropdownStyle}>
                            {this.props.dropdown}
                        </div>
                    )}
                    {explainer}
                </div>
            </ClickAway>
        )
    }
}

const CustomDatePicker = forwardRef(
    (
        {
            value,
            onClick,
            classes,
            fullDate,
            disabled,
            single = false,
            readOnlyInput = false,
            onDateChange = () => {},
            onBlur,
            id,
            timeOnly = false,
            hideIcon = false
        },
        ref
    ) => {
        const user = useSelector((state) => state.user)
        const [date, setDate] = useState(readOnlyInput ? null : moment(value))

        const handleChange = (e) => {
            if (readOnlyInput || disabled) return
            const val = e.currentTarget.value
            setDate(val)
        }

        const checkDate = () => {
            if (readOnlyInput || disabled) return
            const validDate = moment(date, user.userData.dateFormat)
            if (validDate.isValid()) {
                if (fullDate) {
                    const full = moment(full)
                    validDate.hour(full.hour())
                    validDate.minute(full.minute())
                }
                onDateChange(validDate)
            } else {
                setDate(moment(value))
            }
        }

        useEffect(() => {
            if (readOnlyInput || disabled) return
            setDate(value)
        }, [value])

        return (
            <>
                <input
                    id={id}
                    className={classes + ' datepicker ' + (readOnlyInput || disabled ? 'readonly' : '')}
                    disabled={disabled}
                    onClick={disabled ? undefined : onClick}
                    ref={ref}
                    value={readOnlyInput || disabled ? value : date}
                    onBlur={checkDate}
                    onChange={handleChange}
                />
                {!hideIcon && (
                    <Icons
                        icon={timeOnly ? 'clock' : 'calendar'}
                        color='#969695'
                        className={'vertical-center mar-r10 ' + (single ? 'datepicker-icon-inline' : '')}
                        onClick={disabled ? undefined : onClick}
                    />
                )}
            </>
        )
    }
)
